import React, { useEffect, useState } from 'react'
import standardStyle from 'assets/css/standardStyle'
import { FadedAnimatedDiv, LottieWrapper, PageHeader } from 'components'
import tableLoading from '../../assets/lottieJsons/tableLoading.json'
import { deleteEmailCampaigns, getAllEmailCampaigns } from 'store/actions/customEmailCampaignActions'
import DeleteModal from 'components/DeleteModal'
import { useHistory } from 'react-router-dom'

const Card = ({ title, value }) => (
  <div className=''>
    <div
      className='bg-white rounded h-full p-6'
      style={{ fontFamily: standardStyle.fonts.sfpro }}
    >
      <div className='h-full flex flex-col justify-between space-y-2'>
        <div className='text-xs text-softBlack_70 font-medium uppercase'>
          {title}
        </div>
        <div className='text-xl text-softBlack font-bold'>{value}</div>
      </div>
    </div>
  </div>
)

export default function EmailCustomCampaignPage () {
  const history = useHistory()
  const [campaigns, setCampaigns] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deletedToBeCampaign, setDeletedToBeCampaign] = useState({})
  const [analytics, setAnalytic] = useState({
    total_campaign: 0,
    total_email_sent: 0,
    total_opened: 0,
    total_clicked: 0,
    total_bounced: 0,
    total_unsubscribed: 0
  })

  const getCampaigns = () => {
    getAllEmailCampaigns()
      .then((campaigns) => {
        setCampaigns(campaigns)
        setAnalytic({
          ...analytics,
          total_campaign: campaigns.length
        })
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getCampaigns()
  }, [])

  const deleteCampaign = () => {
    deleteEmailCampaigns(deletedToBeCampaign.emailTemplateId._id, deletedToBeCampaign._id)
      .then((res) => {
        setIsLoading(true)
        setDeletedToBeCampaign({})
        getCampaigns()
        setShowDeleteModal(false)
      })
    setDeletedToBeCampaign({})
  }

  return (
    <>
      <PageHeader
        title='Email Custom Campaigns Reports'
      />
      <div className='px-4 sm:px-6 lg:px-8 mt-4'>
        <div className='grid grid-cols-6 gap-4 pt-4'>
          <Card title={'Campaign Sent'} value={analytics.total_campaign} />
          <Card title={'Total Email Sent'} value={analytics.total_email_sent} />
          <Card title={'Total opened'} value={analytics.total_opened} />
          <Card title={'Total clicked'} value={analytics.total_clicked} />
          <Card title={'Total Bounces'} value={analytics.total_bounced} />
          <Card title={'Total Unsubscribed'} value={analytics.total_unsubscribed} />
        </div>
        <div className='mt-8 bg-white rounded p-4'>
          {isLoading &&
            <FadedAnimatedDiv
              key='loadingTable'
              className='w-full h-full flex items-center justify-center my-10 flex-col'
            >
              <LottieWrapper
                animation={tableLoading}
                loop
                className='h-16 w-16'
              />
              <span className='text-base'>loading...</span>
            </FadedAnimatedDiv>
          }
          {!isLoading &&
            <div className='overflow-x-auto'>
              <div className='inline-block min-w-full align-middle'>
                <table className='min-w-full divide-y divide-gray-300'>
                  <thead>
                    <tr>
                      <th
                        scope='col'
                        className='p-4 text-left text-sm font-semibold text-gray-900'
                      >
                        Campaign Name
                      </th>
                      <th
                        scope='col'
                        className='p-4 text-left text-sm font-semibold text-gray-900'
                      >
                        Template Name
                      </th>
                      <th
                        scope='col'
                        className='p-4text-left text-sm font-semibold text-gray-900'
                      >
                      </th>
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200'>
                    {campaigns?.map((campaign) => (
                      <tr key={campaign._id} className={`${!campaign?.emailTemplateId?.id ? 'bg-grey-7 bg-opacity-60' : ''}`}>
                        <td className='whitespace-nowrap p-4 text-sm text-gray-900'>
                          {campaign.name}
                        </td>
                        <td className='whitespace-nowrap p-4 text-sm text-gray-900'>
                          <span
                            className='hover:text-blue-600 cursor-pointer hover:border-b hover:border-b-blue-600 transition-all'
                            onClick={() => history.push(`/admin/email-builder/edit/${campaign.emailTemplateId._id}`)}
                          >
                            {campaign?.emailTemplateId?.name}
                          </span>
                        </td>
                        <td className='whitespace-nowrap py-4 text-sm text-gray-900'>
                          <div className='flex gap-3 w-full items-center content-center justify-end'>
                            <button
                              disabled={!campaign?.emailTemplateId?.id}
                              className='text-softBlack text-center bg-volt text-base font-medium py-2 px-6 flex items-center border border-volt'
                              onClick={() => {
                                setShowDeleteModal(true)
                                setDeletedToBeCampaign(campaign)
                              }}
                            >
                              {!campaign?.emailTemplateId?.id ? 'Archived' : 'Delete'}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>
      </div>
      <DeleteModal
        title='Are you sure?'
        description='Do you want to delete?'
        confirmButtonTitle='Delete Campaign'
        cancelButtonTitle='Cancel'
        isOpen={showDeleteModal}
        setIsOpen={setShowDeleteModal}
        onConfirm={deleteCampaign}
        loading={undefined}
      />
    </>
  )
}
